import { Injectable } from '@angular/core';
import { Http} from '@angular/http';
import { environment } from '../../../../../environments/environment';
import 'rxjs/add/operator/toPromise';
import {EnvLoadService} from '../../../../env-load/env-load.service';

@Injectable()
export class NotificationHistoryServices {
    private apiUrl = `${environment.apiUrl}/api/v1`;
    private companyId = global['loginUser'].curCmpnId;

    constructor(private http: Http,
                private envLoadService: EnvLoadService) {
        this.companyId = global['loginUser'].curCmpnId;
    }

    /**
     * notification history
     * 알림 이력 목록 조회
     * Mothod : Get
     * API No : 19.1
     * /api/v1/{cmpnNo}/notihist
     */
    getNotificationHistoryList(queryString) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/notihist${queryString}`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }


    private handleError(error: any) {
        //console.error('An error occurred', error);
        return Promise.resolve(error.message || error);
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/services/src/api/notification-history.services.ts